var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIconNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 16.6666H5.83317C6.05418 16.6666 6.26615 16.5788 6.42243 16.4225C6.57871 16.2663 6.6665 16.0543 6.6665 15.8333C6.6665 15.6123 6.57871 15.4003 6.42243 15.244C6.26615 15.0878 6.05418 15 5.83317 15H4.99984L4.99984 4.99996H5.83317C6.05418 4.99996 6.26615 4.91216 6.42243 4.75588C6.57871 4.5996 6.6665 4.38764 6.6665 4.16663C6.6665 3.94561 6.57871 3.73365 6.42243 3.57737C6.26615 3.42109 6.05418 3.33329 5.83317 3.33329H4.1665C3.94549 3.33329 3.73353 3.42109 3.57725 3.57737C3.42097 3.73365 3.33317 3.94561 3.33317 4.16663L3.33317 15.8333C3.33317 16.0543 3.42097 16.2663 3.57725 16.4225C3.73353 16.5788 3.94549 16.6666 4.1665 16.6666Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 13.8333C10.2993 14.0101 10.4967 14.127 10.7155 14.1582C10.9343 14.1895 11.1565 14.1326 11.3333 14C11.5101 13.8673 11.627 13.6699 11.6583 13.4511C11.6895 13.2323 11.6326 13.0101 11.5 12.8333L10 10.8333H16.6667C16.8877 10.8333 17.0996 10.7455 17.2559 10.5892C17.4122 10.4329 17.5 10.221 17.5 9.99996C17.5 9.77894 17.4122 9.56698 17.2559 9.4107C17.0996 9.25442 16.8877 9.16662 16.6667 9.16662H9.925L11.3583 7.13329C11.4223 7.04372 11.4678 6.94237 11.4924 6.8351C11.517 6.72782 11.5201 6.61675 11.5015 6.50828C11.4829 6.39981 11.443 6.29609 11.3841 6.20313C11.3252 6.11016 11.2485 6.02978 11.1583 5.96662C11.0167 5.86773 10.8478 5.81531 10.675 5.81662C10.5428 5.81723 10.4126 5.84929 10.2953 5.91015C10.1779 5.97101 10.0767 6.05892 10 6.16662L7.65 9.49996C7.54571 9.64267 7.4895 9.81486 7.4895 9.99162C7.4895 10.1684 7.54571 10.3406 7.65 10.4833L10.1667 13.8333Z",
    fill: "#808080"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 -1 20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconNav);
export default __webpack_public_path__ + "static/media/logout_icon-nav.c6a5273556ff6039379d4042518e2409.svg";
export { ForwardRef as ReactComponent };